// Activity Templates Index
// Each template exports both an input form (Template) and display component (Display)

// ──────────────────────────────────────────────────────────────────────────────
// RACKET SPORTS
// ──────────────────────────────────────────────────────────────────────────────

export {
  BadmintonDisplay,
  type BadmintonParticipant,
  BadmintonTemplate,
  type BadmintonTemplateData,
} from "./badminton-template";
export {
  PadelDisplay,
  type PadelParticipant,
  PadelTemplate,
  type PadelTemplateData,
} from "./padel-template";
export {
  PickleballDisplay,
  type PickleballParticipant,
  PickleballTemplate,
  type PickleballTemplateData,
} from "./pickleball-template";

export {
  SquashDisplay,
  type SquashParticipant,
  SquashTemplate,
  type SquashTemplateData,
} from "./squash-template";
export {
  TableTennisDisplay,
  type TableTennisParticipant,
  TableTennisTemplate,
  type TableTennisTemplateData,
} from "./table-tennis-template";
export {
  TennisDisplay,
  type TennisParticipant,
  TennisTemplate,
  type TennisTemplateData,
} from "./tennis-template";

// ──────────────────────────────────────────────────────────────────────────────
// TEAM SPORTS
// ──────────────────────────────────────────────────────────────────────────────

export {
  BasketballDisplay,
  type BasketballParticipant,
  BasketballTemplate,
  type BasketballTemplateData,
} from "./basketball-template";
export {
  CricketDisplay,
  type CricketParticipant,
  CricketTemplate,
  type CricketTemplateData,
} from "./cricket-template";
export {
  FootballDisplay,
  type FootballParticipant,
  FootballTemplate,
  type FootballTemplateData,
} from "./football-template";

export {
  ThrowballDisplay,
  type ThrowballParticipant,
  ThrowballTemplate,
  type ThrowballTemplateData,
} from "./throwball-template";
export {
  VolleyballDisplay,
  type VolleyballParticipant,
  VolleyballTemplate,
  type VolleyballTemplateData,
} from "./volleyball-template";

// ──────────────────────────────────────────────────────────────────────────────
// PERFORMANCE ACTIVITIES
// ──────────────────────────────────────────────────────────────────────────────

export {
  RunningDisplay,
  type RunningParticipant,
  type RunningTemplateData,
} from "./running-template";
export { SwimmingDisplay } from "./swimming-template";
export {
  WalkingDisplay,
  type WalkingParticipant,
  type WalkingTemplateData,
} from "./walking-template";

// ──────────────────────────────────────────────────────────────────────────────
// SESSION-BASED ACTIVITIES
// ──────────────────────────────────────────────────────────────────────────────

export {
  CyclingDisplay,
  type CyclingParticipant,
  type CyclingTemplateData,
} from "./cycling-template";
export { TrekkingDisplay } from "./trekking-template";
export {
  WeightTrainingDisplay,
  type WeightTrainingParticipant,
  type WeightTrainingTemplateData,
} from "./weight-training-template";

// ──────────────────────────────────────────────────────────────────────────────
// SPECIALTY ACTIVITIES
// ──────────────────────────────────────────────────────────────────────────────

export {
  SnookerDisplay,
  type SnookerParticipant,
  SnookerTemplate,
  type SnookerTemplateData,
} from "./snooker-template";

// ──────────────────────────────────────────────────────────────────────────────
// SCORECARDS
// ──────────────────────────────────────────────────────────────────────────────

export { ActivityScorecard } from "./activity-scorecard";

// ──────────────────────────────────────────────────────────────────────────────
// SCORE EDITORS
// ──────────────────────────────────────────────────────────────────────────────

export {
  ActivityScoreEditor,
  type ActivityScoreEditorProps,
} from "./score-editors";

// ──────────────────────────────────────────────────────────────────────────────
// COURT PREVIEWS
// ──────────────────────────────────────────────────────────────────────────────

export {
  ActivityCourtPreview,
  type ActivityCourtPreviewProps,
  ActivityDisplayPreview,
  type ActivityDisplayPreviewProps,
} from "./previews";

export {
  BadmintonScorecard,
  BasketballScorecard,
  CricketScorecard,
  FootballScorecard,
  PadelScorecard,
  PickleballScorecard,
  ScorecardShell,
  type ScorecardVariant,
  SnookerScorecard,
  SquashScorecard,
  TableTennisScorecard,
  TennisScorecard,
  ThrowballScorecard,
  VolleyballScorecard,
} from "./scorecards";

// ──────────────────────────────────────────────────────────────────────────────
// BASE COMPONENTS
// ──────────────────────────────────────────────────────────────────────────────

export {
  MatchResult,
  ModeToggle,
  type Participant as MatchParticipant,
  ParticipantList as MatchParticipantList,
  ScoreCounter,
  suggestionToParticipant as matchSuggestionToParticipant,
  TeamCard,
  ValidationWarning,
} from "./base-match-template";

export {
  DistanceInput,
  DurationPicker,
  type IntensityLevel,
  IntensitySelector,
  LocationInput,
  type Participant as SessionParticipant,
  ParticipantList as SessionParticipantList,
  StyleSelector,
  suggestionToParticipant as sessionSuggestionToParticipant,
  TimeInput,
} from "./base-session-template";
